import axios from '../../config/axiosConfig';
import { CREATE_COLOR, GET_COLOR, COLOR_REQUEST, DELETE_COLOR, 
UPDATE_COLOR, COLOR_REQUEST_FAILURE, GET_COLOR_PAGE } from '../types';
import { addMasterInOption, updateMasterInOption } from './master-options-actions';

export const getColorsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: COLOR_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
      };
      return axios.get("/color/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_COLOR_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: COLOR_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: COLOR_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getColors = (commonMaster) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: COLOR_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id };
            if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            }
            if (commonMaster !== undefined) {
                params = {
                  ...params,
                  companyId: commonMaster ? undefined : auth.company?.id
                };
            }
            return axios.get('/color/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_COLOR, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: COLOR_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: COLOR_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const createColor = (data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            const { colors } = getState();
            dispatch({ type: COLOR_REQUEST });

            return axios.post('/color/add', data,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}).then( async (response) => {
                    if (response.data) {
                        dispatch({ type: CREATE_COLOR, payload: response.data });
                        // Re-fetch the current page to get updated data
                        await dispatch(getColorsWithPagination(
                            colors.page || 1,           // current page
                            colors.pageSize || 10,      // current page size
                            undefined,                  // include
                            colors.search || '',        // current search
                            undefined,                  // searchCols
                            colors.where || {},         // current filters
                            true                        // addTotal
                        ));
                        dispatch(addMasterInOption('colors', response.data));
                    } else {
                        dispatch({ type: COLOR_REQUEST_FAILURE, error: 'color create failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: COLOR_REQUEST_FAILURE, error: error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: COLOR_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateColor = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            const { colors } = getState();
            dispatch({ type: COLOR_REQUEST });
            return axios.put('/color/update', { id, data }, { params: { userId: auth.user?.id }}).then( async (response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_COLOR, payload: { id, data: response.data } });
                    // Re-fetch the current page to get updated data
                    await dispatch(getColorsWithPagination(
                        colors.page || 1,           // current page
                        colors.pageSize || 10,      // current page size
                        undefined,                  // include
                        colors.search || '',        // current search
                        undefined,                  // searchCols
                        colors.where || {},         // current filters
                        true                        // addTotal
                    ));
                    dispatch(updateMasterInOption('colors', id, response.data));
                } else {
                    dispatch({ type: COLOR_REQUEST_FAILURE, error: 'color update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: COLOR_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: COLOR_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteColor = (id) => {
    return async (dispatch, getState) => {
        try {
            const { colors } = getState();
            dispatch({ type: COLOR_REQUEST });
            return axios.delete(`/color/delete/${id}`).then( async (response) => {
                if (response.data) {
                    dispatch({ type: DELETE_COLOR, id: id });
                    // Re-fetch the current page to get updated data
                    await dispatch(getColorsWithPagination(
                        colors.page || 1,           // current page
                        colors.pageSize || 10,      // current page size
                        undefined,                  // include
                        colors.search || '',        // current search
                        undefined,                  // searchCols
                        colors.where || {},         // current filters
                        true                        // addTotal
                    ));
                    dispatch(updateMasterInOption('colors', id));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: COLOR_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: COLOR_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};